import * as React from "react";
const SvgAgentLeadIcon = ({ color }) => (
  <svg width={21} height={19} fill="none">
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M14.1 4.6c0-.837 0-1.255-.092-1.599a2.7 2.7 0 0 0-1.91-1.909C11.756 1 11.338 1 10.5 1c-.837 0-1.255 0-1.599.092a2.7 2.7 0 0 0-1.909 1.91C6.9 3.344 6.9 3.762 6.9 4.6M4.38 17.2h12.24c1.008 0 1.512 0 1.897-.196a1.8 1.8 0 0 0 .787-.787c.196-.385.196-.889.196-1.897V7.48c0-1.008 0-1.512-.196-1.897a1.8 1.8 0 0 0-.787-.787c-.385-.196-.889-.196-1.897-.196H4.38c-1.008 0-1.512 0-1.897.196a1.8 1.8 0 0 0-.787.787C1.5 5.968 1.5 6.472 1.5 7.48v6.84c0 1.008 0 1.512.196 1.897a1.8 1.8 0 0 0 .787.787c.385.196.889.196 1.897.196Z"
    />
  </svg>
);
export default SvgAgentLeadIcon;
